import { MULTICALL_NETWORKS_ADDRESS, MULTICALL_NETWORKS2_ADDRESS } from '@stichting-allianceblock-foundation/alliance-dex-sdk'
import MULTICALL_ABI from './abi.json'
import MULTICALL2_ABI from './abi2.json'
// import Multicall from './Multicall.json';
// const MULTICALL_ABI = Multicall.abi;

const MULTICALL_NETWORKS = MULTICALL_NETWORKS_ADDRESS;
const MULTICALL_NETWORKS2 = MULTICALL_NETWORKS2_ADDRESS;

export { MULTICALL_ABI, MULTICALL2_ABI, MULTICALL_NETWORKS, MULTICALL_NETWORKS2 }
